import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../utils/api';
import '../styles/global.css';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await api.post('/auth/forgot-password', { email });
      setSent(true);
    } catch (err) {
      // Always show success to prevent email enumeration
      setSent(true);
    }
    setLoading(false);
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <h1 className="login-title">Leadiox</h1>
        <p className="login-subtitle">Reset Your Password</p>

        {sent ? (
          <div>
            <div style={{ textAlign: 'center', padding: '20px 0' }}>
              <div style={{ fontSize: 40, marginBottom: 12 }}>&#9993;</div>
              <p style={{ fontWeight: 500, marginBottom: 8 }}>Check your email</p>
              <p className="text-muted text-sm">If an account exists for <strong>{email}</strong>, we sent a password reset link. It expires in 1 hour.</p>
            </div>
            <div className="login-toggle" style={{ marginTop: 20 }}>
              <Link to="/login">Back to Sign In</Link>
            </div>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <p className="text-muted text-sm" style={{ marginBottom: 16 }}>Enter your email and we'll send you a link to reset your password.</p>
            {error && <div className="login-error">{error}</div>}
            <div className="form-group">
              <label className="form-label">Email</label>
              <input type="email" className="form-input" value={email} onChange={e => setEmail(e.target.value)} placeholder="you@hotel.com" required autoFocus />
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 12, marginTop: 8 }}>
              <button type="submit" className="btn btn-primary btn-lg" style={{ minWidth: 180, width: 'auto' }} disabled={loading}>
                {loading ? 'Sending...' : 'Send Reset Link'}
              </button>
            </div>
            <div className="login-toggle">
              <Link to="/login">Back to Sign In</Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
